var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container SupplierDataEdit" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("settlementUnit.SupplierDataInfo"),
                name: "1",
              },
            },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.auditStatus == "draft" ||
                            _vm.auditStatus == "appr_rej" ||
                            (_vm.auditStatus == "appr_pass" &&
                              _vm.emplFlag == "MDM"),
                          expression:
                            "auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')",
                        },
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SubmitUnitOfAccount,
                          expression: "SubmitUnitOfAccount",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.saveDetail },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.auditStatus == "draft" ||
                              _vm.auditStatus == "appr_rej" ||
                              (_vm.auditStatus == "appr_pass" &&
                                _vm.emplFlag == "MDM")) &&
                            _vm.id != null,
                          expression:
                            "(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')) && id != null",
                        },
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SubmitUnitOfAccount,
                          expression: "SubmitUnitOfAccount",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.submitDetail },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.submit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.canAudit && _vm.auditStatus != "appr_rej",
                          expression: "canAudit && auditStatus != 'appr_rej'",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.approvalFun },
                    },
                    [_vm._v(_vm._s(_vm.$t("supplierManage.audit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.auditStatus == "appr_pass" &&
                            _vm.emplFlag == "MDM",
                          expression:
                            "auditStatus == 'appr_pass' && emplFlag == 'MDM'",
                        },
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SendUnitOfAccountToMDM,
                          expression: "SendUnitOfAccountToMDM",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.sendToMDM },
                    },
                    [_vm._v(_vm._s(_vm.$t("settlementUnit.sendToMDM")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RecallUnitOfAccount,
                          expression: "RecallUnitOfAccount",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.auditStatus == "appr_in" ||
                              _vm.auditStatus == "appr_rej") &&
                            _vm.unitOfAccountForm.hasHistory,
                          expression:
                            "(auditStatus == 'appr_in' || auditStatus == 'appr_rej') && unitOfAccountForm.hasHistory",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.withdrawFun },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.withdraw")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("settlementUnit.dataInfo"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "unitOfAccountForm",
                      attrs: {
                        model: _vm.unitOfAccountForm,
                        rules: _vm.unitOfAccountRules,
                        "label-width": "160px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _vm.emplFlag == "SUP"
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "settlementUnit.suppliercodeOrInvitationCode"
                                        ),
                                        prop: "groupSupplierCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          maxlength: "20",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.unitOfAccountForm
                                              .groupSupplierCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.unitOfAccountForm,
                                              "groupSupplierCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "unitOfAccountForm.groupSupplierCode",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "settlementUnit.suppliercodeOrInvitationCode"
                                        ),
                                        prop: "groupSupplierCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          clearable: "",
                                          maxlength: "20",
                                          disabled: !(
                                            _vm.auditStatus == "draft" ||
                                            _vm.auditStatus == "appr_rej" ||
                                            (_vm.auditStatus == "appr_pass" &&
                                              _vm.emplFlag == "MDM")
                                          ),
                                        },
                                        on: {
                                          input: _vm.blurGroupSupplierCode,
                                          clear: _vm.clearGroupSupplierCode,
                                        },
                                        model: {
                                          value:
                                            _vm.unitOfAccountForm
                                              .groupSupplierCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.unitOfAccountForm,
                                              "groupSupplierCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "unitOfAccountForm.groupSupplierCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.supplierType"
                                    ),
                                    prop: "groupType",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      table: "TM_SUPPLIER",
                                      field: "GROUP_TYPE",
                                      clearable: "",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.unitOfAccountForm.groupType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "groupType",
                                          $$v
                                        )
                                      },
                                      expression: "unitOfAccountForm.groupType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.supplierAbbreviation"
                                    ),
                                    prop: "nameShort",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { clearable: "", disabled: "" },
                                    model: {
                                      value: _vm.unitOfAccountForm.nameShort,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "nameShort",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "unitOfAccountForm.nameShort",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.supplierNameCn"
                                    ),
                                    prop: "nameCn",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "20",
                                      clearable: "",
                                      disabled: !(
                                        _vm.auditStatus == "draft" ||
                                        _vm.auditStatus == "appr_rej" ||
                                        (_vm.auditStatus == "appr_pass" &&
                                          _vm.emplFlag == "MDM")
                                      ),
                                    },
                                    model: {
                                      value: _vm.unitOfAccountForm.nameCn,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "nameCn",
                                          $$v
                                        )
                                      },
                                      expression: "unitOfAccountForm.nameCn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.suppliernameEn"
                                    ),
                                    prop: "nameEn",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "100",
                                      clearable: "",
                                      disabled: !(
                                        _vm.auditStatus == "draft" ||
                                        _vm.auditStatus == "appr_rej" ||
                                        (_vm.auditStatus == "appr_pass" &&
                                          _vm.emplFlag == "MDM")
                                      ),
                                    },
                                    model: {
                                      value: _vm.unitOfAccountForm.nameEn,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "nameEn",
                                          $$v
                                        )
                                      },
                                      expression: "unitOfAccountForm.nameEn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.queryConditionSupplierCode"
                                    ),
                                    prop: "code",
                                    rules:
                                      (!_vm.$route.query.id ||
                                        _vm.canAudit ||
                                        ((_vm.auditStatus == "draft" ||
                                          _vm.auditStatus == "appr_rej") &&
                                          _vm.unitOfAccountForm.createType ==
                                            "MDM")) &&
                                      _vm.emplFlag == "MDM" &&
                                      _vm.unitOfAccountForm.groupType ==
                                        "CARRIER"
                                        ? _vm.unitOfAccountRules.code
                                        : [{ required: false }],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      disabled:
                                        (!_vm.$route.query.id ||
                                          _vm.canAudit ||
                                          ((_vm.auditStatus == "draft" ||
                                            _vm.auditStatus == "appr_rej") &&
                                            _vm.unitOfAccountForm.createType ==
                                              "MDM")) &&
                                        _vm.emplFlag == "MDM" &&
                                        _vm.unitOfAccountForm.groupType ==
                                          "CARRIER"
                                          ? false
                                          : true,
                                    },
                                    model: {
                                      value: _vm.unitOfAccountForm.code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "code",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "unitOfAccountForm.code",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "GLN", prop: "gln" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "13",
                                      clearable: "",
                                      disabled: !(
                                        _vm.auditStatus == "draft" ||
                                        _vm.auditStatus == "appr_rej" ||
                                        (_vm.auditStatus == "appr_pass" &&
                                          _vm.emplFlag == "MDM")
                                      ),
                                    },
                                    model: {
                                      value: _vm.unitOfAccountForm.gln,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "gln",
                                          $$v
                                        )
                                      },
                                      expression: "unitOfAccountForm.gln",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("supplierManage.auditStatus"),
                                    prop: "auditStatus",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      clearable: "",
                                      table: "TM_UNIT_OF_ACCOUNT",
                                      field: "STATUS",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.unitOfAccountForm.auditStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "auditStatus",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "unitOfAccountForm.auditStatus",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "supplierManage.socialUniformCreditCode"
                                    ),
                                    prop: "socialUniformCreditCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      disabled: !(
                                        _vm.auditStatus == "draft" ||
                                        _vm.auditStatus == "appr_rej" ||
                                        (_vm.auditStatus == "appr_pass" &&
                                          _vm.emplFlag == "MDM")
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.unitOfAccountForm
                                          .socialUniformCreditCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.unitOfAccountForm,
                                          "socialUniformCreditCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "unitOfAccountForm.socialUniformCreditCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.emplFlag == "MDM"
                            ? _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "settlementUnit.department"
                                        ),
                                        prop: "department",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_SUPPLIER",
                                          field: "DEPARTMENT",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.unitOfAccountForm.department,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.unitOfAccountForm,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "unitOfAccountForm.department",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.emplFlag == "MDM"
                            ? _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("common.status"),
                                        prop: "status",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: _vm.$t("common.sel"),
                                            disabled: !(
                                              _vm.auditStatus == "draft" ||
                                              _vm.auditStatus == "appr_rej" ||
                                              (_vm.auditStatus == "appr_pass" &&
                                                _vm.emplFlag == "MDM")
                                            ),
                                          },
                                          model: {
                                            value: _vm.unitOfAccountForm.status,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.unitOfAccountForm,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "unitOfAccountForm.status",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "base.common.statusAble"
                                              ),
                                              value: "1",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "base.common.statusDisable"
                                              ),
                                              value: "0",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "已淘汰",
                                              value: "2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("settlementUnit.SubmitBy"),
                                    prop: "ssCategoryLeaderId",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.unitOfAccountForm
                                            .ssCategoryLeaderId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.unitOfAccountForm,
                                            "ssCategoryLeaderId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "unitOfAccountForm.ssCategoryLeaderId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.SubmitBySSList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.userName,
                                            value: item.tmUserId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("settlementUnit.contacts"))),
                      ]),
                    ]
                  ),
                  _vm.auditStatus == "draft" ||
                  _vm.auditStatus == "appr_rej" ||
                  (_vm.auditStatus == "appr_pass" && _vm.emplFlag == "MDM")
                    ? _c(
                        "div",
                        { staticClass: "toolsBox" },
                        [
                          _vm.formlinkUsers.linkUsersList.length < 5 &&
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.SubmitUnitOfAccount,
                                      expression: "SubmitUnitOfAccount",
                                    },
                                  ],
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addUser()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                              )
                            : _vm._e(),
                          _vm.isShow
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.SubmitUnitOfAccount,
                                      expression: "SubmitUnitOfAccount",
                                    },
                                  ],
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delUser()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.del")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      ref: "formlinkUsers",
                      attrs: {
                        model: _vm.formlinkUsers,
                        rules: _vm.ruleslinkUsers,
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "linkUsersList",
                          attrs: {
                            data: _vm.formlinkUsers.linkUsersList,
                            border: "",
                            "highlight-current-row": "",
                            "max-height": "420",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "trLinkUserId",
                              type: "selection",
                              "min-width": "55",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "name",
                              label: _vm.$t("settlementUnit.contacts"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "linkUsersList." +
                                            scope.$index +
                                            ".name",
                                          rules: _vm.ruleslinkUsers.name,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            model: {
                                              value: scope.row.name,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "name", $$v)
                                              },
                                              expression: "scope.row.name",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "tel",
                              label: _vm.$t("settlementUnit.tel"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "linkUsersList." +
                                            scope.$index +
                                            ".tel",
                                          rules: _vm.ruleslinkUsers.tel,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: { maxlength: "60" },
                                            model: {
                                              value: scope.row.tel,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "tel", $$v)
                                              },
                                              expression: "scope.row.tel",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "officeTel",
                              label: "办公室电话",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "linkUsersList." +
                                            scope.$index +
                                            ".officeTel",
                                          rules: _vm.ruleslinkUsers.tel,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: { maxlength: "60" },
                                            model: {
                                              value: scope.row.officeTel,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "officeTel",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.officeTel",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "email",
                              label: _vm.$t("sys.userList.email"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "linkUsersList." +
                                            scope.$index +
                                            ".email",
                                          rules: _vm.ruleslinkUsers.email,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: { maxlength: "50" },
                                            model: {
                                              value: scope.row.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.email",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "title",
                              label: _vm.$t("supplierManage.position"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "linkUsersList." +
                                            scope.$index +
                                            ".title",
                                          rules: _vm.ruleslinkUsers.title,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            model: {
                                              value: scope.row.title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.title",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("settlementUnit.addressInformation"))
                        ),
                      ]),
                      _c("span", { staticClass: "addressInformationTip" }, [
                        _vm._v(
                          _vm._s(_vm.$t("settlementUnit.addressInformationTip"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.auditStatus == "draft" ||
                              _vm.auditStatus == "appr_rej" ||
                              (_vm.auditStatus == "appr_pass" &&
                                _vm.emplFlag == "MDM"),
                            expression:
                              "auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')",
                          },
                        ],
                        staticClass: "toolsBox",
                      },
                      [
                        _vm.unitOfAccountForm.groupType != "CARRIER" &&
                        _vm.isShow
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "acl",
                                    rawName: "v-acl",
                                    value: _vm.SubmitUnitOfAccount,
                                    expression: "SubmitUnitOfAccount",
                                  },
                                ],
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addSupplierAddress()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                            )
                          : _vm._e(),
                        _vm.unitOfAccountForm.groupType != "CARRIER" &&
                        _vm.isShow
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "acl",
                                    rawName: "v-acl",
                                    value: _vm.SubmitUnitOfAccount,
                                    expression: "SubmitUnitOfAccount",
                                  },
                                ],
                                attrs: { type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delSupplierAddress()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.del")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.auditStatus == "appr_pass" && _vm.emplFlag == "MDM"
                      ? _c(
                          "div",
                          {
                            staticClass: "toolsBox",
                            staticStyle: { "margin-left": "12px" },
                          },
                          [
                            _vm.emplFlag == "MDM"
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.SubmitUnitOfAccount,
                                        expression: "SubmitUnitOfAccount",
                                      },
                                    ],
                                    attrs: { type: " primary" },
                                    on: { click: _vm.editPlant },
                                  },
                                  [_vm._v("工厂编码修改")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "formAddress",
                      attrs: {
                        model: _vm.formAddress,
                        rules: _vm.rulesAddress,
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plantList",
                          attrs: {
                            data: _vm.formAddress.plantList,
                            border: "",
                            "highlight-current-row": "",
                            "max-height": "420",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "tmSupplierId",
                              type: "selection",
                              "min-width": "55",
                              selectable: (row, index) => index != 0,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "nameCn",
                              label: _vm.$t("sys.roleList.roleCN"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "plantList." +
                                            scope.$index +
                                            ".nameCn",
                                          rules: _vm.rulesAddress.nameCn,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              maxlength: "33",
                                              disabled:
                                                scope.$index != 0 &&
                                                _vm.unitOfAccountForm
                                                  .groupType == "SUPPLIER",
                                            },
                                            model: {
                                              value: scope.row.nameCn,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "nameCn",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.nameCn",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "nameEn",
                              label: _vm.$t("sys.roleList.roleEN"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "plantList." +
                                            scope.$index +
                                            ".nameEn",
                                          rules: _vm.rulesAddress.nameEn,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              maxlength: "100",
                                              disabled:
                                                scope.$index != 0 &&
                                                _vm.unitOfAccountForm
                                                  .groupType == "SUPPLIER",
                                            },
                                            model: {
                                              value: scope.row.nameEn,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "nameEn",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.nameEn",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "plantType",
                              label: _vm.$t("settlementUnit.addressType"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "plantList." +
                                            scope.$index +
                                            ".plantType",
                                          rules: _vm.rulesAddress.plantType,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { disabled: "" },
                                            model: {
                                              value: scope.row.plantType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "plantType",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.plantType",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              key: "REG",
                                              attrs: {
                                                label:
                                                  _vm.$t("settlementUnit.cra"),
                                                value: "REG",
                                              },
                                            }),
                                            _c("el-option", {
                                              key: "PLANT",
                                              attrs: {
                                                label: _vm.$t(
                                                  "settlementUnit.factoryAddress"
                                                ),
                                                value: "PLANT",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm.emplFlag == "MDM"
                            ? _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  prop: "plantCode",
                                  label: _vm.$t("settlementUnit.code"),
                                  "min-width": "50",
                                },
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "areaId",
                              label: _vm.$t("supplierManage.area"),
                              "min-width": "160",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.areaId
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectArea(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.countryName) +
                                                _vm._s(scope.row.provinceName) +
                                                _vm._s(scope.row.cityName) +
                                                _vm._s(scope.row.areaName)
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectArea(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("supplierManage.area")
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "address",
                              label: _vm.$t("settlementUnit.detailAddress"),
                              "min-width": "140",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "plantList." +
                                            scope.$index +
                                            ".address",
                                          rules: _vm.rulesAddress.address,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              disabled:
                                                scope.$index != 0 &&
                                                _vm.unitOfAccountForm
                                                  .groupType == "SUPPLIER",
                                            },
                                            model: {
                                              value: scope.row.address,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "address",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.address",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "linkman",
                              label: _vm.$t("settlementUnit.contacts"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.users &&
                                    scope.row.users.length > 0
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              _vm._l(
                                                scope.row.users,
                                                function (item, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "settlementUnit.contacts"
                                                          )
                                                        ) +
                                                          "：" +
                                                          _vm._s(item.name) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.telephone"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.tel) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.email"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.email)
                                                      ),
                                                      _c("br"),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addAddressUser(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.users[0].name
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addAddressUser(
                                                  scope.row,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("settlementUnit.addTo")
                                              )
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "tel",
                              label: _vm.$t("settlementUnit.tel"),
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.users &&
                                    scope.row.users.length > 0
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              _vm._l(
                                                scope.row.users,
                                                function (item, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "settlementUnit.contacts"
                                                          )
                                                        ) +
                                                          "：" +
                                                          _vm._s(item.name) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.telephone"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.tel) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.email"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.email)
                                                      ),
                                                      _c("br"),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addAddressUser(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.users[0].tel)
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "officeTel",
                              label: "办公室电话",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.users &&
                                    scope.row.users.length > 0
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              _vm._l(
                                                scope.row.users,
                                                function (item, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "settlementUnit.contacts"
                                                          )
                                                        ) +
                                                          "：" +
                                                          _vm._s(item.name) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.telephone"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.tel) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.email"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.email) +
                                                          "，办公室电话 ：" +
                                                          _vm._s(item.officeTel)
                                                      ),
                                                      _c("br"),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addAddressUser(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.users[0].officeTel
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "email",
                              label: _vm.$t("sys.userList.email"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.users &&
                                    scope.row.users.length > 0
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              _vm._l(
                                                scope.row.users,
                                                function (item, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "settlementUnit.contacts"
                                                          )
                                                        ) +
                                                          "：" +
                                                          _vm._s(item.name) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.telephone"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.tel) +
                                                          "，" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settlementUnit.email"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(item.email)
                                                      ),
                                                      _c("br"),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "el-link",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addAddressUser(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.users[0].email
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "postCode",
                              label: _vm.$t("settlementUnit.Postcode"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "plantList." +
                                            scope.$index +
                                            ".postCode",
                                          rules: _vm.rulesAddress.postCode,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              maxLength: "6",
                                              onkeyup:
                                                "this.value=this.value.replace(/\\D/g,'')",
                                              disabled:
                                                scope.$index != 0 &&
                                                _vm.unitOfAccountForm
                                                  .groupType == "SUPPLIER",
                                            },
                                            model: {
                                              value: scope.row.postCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "postCode",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.postCode",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              label: _vm.$t("settlementUnit.qualificationFile"),
                              "min-width": "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.existsFile == "Y"
                                      ? _c("i", {
                                          staticClass:
                                            "el-icon-folder-checked iconUploadSuccess",
                                        })
                                      : _vm._e(),
                                    _c(
                                      "el-link",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.seeQualificationFile(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.upload")))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              prop: "status",
                              label: _vm.$t("settlementUnit.status"),
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.$index != 0
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "plantList." +
                                                scope.$index +
                                                ".status",
                                              rules: _vm.rulesAddress.status,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !(
                                                      _vm.unitOfAccountForm
                                                        .groupType ==
                                                        "SUPPLIER" &&
                                                      _vm.auditStatus ==
                                                        "appr_pass" &&
                                                      _vm.emplFlag == "MDM"
                                                    ) || _vm.emplFlag == "SUP",
                                                },
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  key: "0",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "settlementUnit.disabled"
                                                    ),
                                                    value: "0",
                                                  },
                                                }),
                                                _c("el-option", {
                                                  key: "1",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "settlementUnit.enabled"
                                                    ),
                                                    value: "1",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.id
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("settlementUnit.qualificationFile"),
                    name: "2",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.LegalFileList,
                        border: "",
                        "highlight-current-row": "",
                        "max-height": "500",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: _vm.$t(
                            "settlementUnit.qualificationDocuments"
                          ),
                          prop: "title",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: _vm.$t("settlementUnit.template"),
                          prop: "templateName",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.downloadTemplate(
                                            scope.row.template,
                                            scope.row.templateName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.templateName) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.downloadTemplate(
                                            scope.row.template2,
                                            scope.row.templateName2
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.templateName2) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4002733510
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: _vm.$t("settlementUnit.historicalFileVersion"),
                          prop: "historyFile",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.historyFile,
                                  function (v, index) {
                                    return _c(
                                      "el-link",
                                      {
                                        key: index,
                                        staticStyle: { display: "block" },
                                        attrs: { type: "primary" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.downloadhistoryFile(v)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(v.documentName) + " ")]
                                    )
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          2902351958
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: _vm.$t("settlementUnit.currentVersionFile"),
                          prop: "currentName",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "primary" },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.downloadLegalFile(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.currentName) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3493304526
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: _vm.$t("settlementUnit.status"),
                          prop: "status",
                          formatter: _vm.formatStatus,
                          width: "160",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: _vm.$t("settlementUnit.operation"),
                          width: "200",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", { staticClass: "operationBox" }, [
                                    scope.$index == 0 ||
                                    scope.$index == 1 ||
                                    scope.$index == 2 ||
                                    scope.$index == 4
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "acl",
                                                    rawName: "v-acl",
                                                    value:
                                                      _vm.SubmitUnitOfAccount,
                                                    expression:
                                                      "SubmitUnitOfAccount",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toLegalFileDetail(
                                                      scope.row.formType
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "settlementUnit.createApplication"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    scope.$index == 3
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "acl",
                                                    rawName: "v-acl",
                                                    value:
                                                      _vm.SubmitUnitOfAccount,
                                                    expression:
                                                      "SubmitUnitOfAccount",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: _vm.toEngagementDetail,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("common.see"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c("div", [
                                          scope.$index != 15
                                            ? _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "acl",
                                                      rawName: "v-acl",
                                                      value:
                                                        _vm.SubmitUnitOfAccount,
                                                      expression:
                                                        "SubmitUnitOfAccount",
                                                    },
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getLegalFileIndex(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      ref: "upload",
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                      attrs: {
                                                        action: "upload",
                                                        "http-request":
                                                          _vm.uploadLegalFile,
                                                        "show-file-list": false,
                                                        multiple: "",
                                                        size: "mini",
                                                        name: "file",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            slot: "trigger",
                                                            size: "small",
                                                            type: "primary",
                                                          },
                                                          slot: "trigger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.upload"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          scope.$index == 15 &&
                                          _vm.emplFlag != "SUP"
                                            ? _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "acl",
                                                      rawName: "v-acl",
                                                      value:
                                                        _vm.SubmitUnitOfAccount,
                                                      expression:
                                                        "SubmitUnitOfAccount",
                                                    },
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getLegalFileIndex(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      ref: "upload",
                                                      staticStyle: {
                                                        "margin-left": "20px",
                                                      },
                                                      attrs: {
                                                        action: "upload",
                                                        "http-request":
                                                          _vm.uploadLegalFile,
                                                        "show-file-list": false,
                                                        multiple: "",
                                                        size: "mini",
                                                        name: "file",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            slot: "trigger",
                                                            size: "small",
                                                            type: "primary",
                                                          },
                                                          slot: "trigger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "settlementUnit.placeFile"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3636738049
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.id
            ? _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("common.approvalLog"), name: "3" } },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.auditLog,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "createDate",
                          label: _vm.$t("common.OperationTime"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateFormatFilter")(
                                        scope.row.createDate,
                                        "YYYY-MM-DD HH:mm:ss"
                                      )
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3398165263
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "operatorName",
                          label: _vm.$t("common.OperatorName"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "action",
                          label: _vm.$t("common.PedagogicalOperation"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "comments",
                          label: _vm.$t("common.opinion"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcMultipleDialog,
            "append-to-body": "",
            width: "85%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcMultipleDialog = $event
            },
            close: _vm.closeSelDcMultipleDialog,
          },
        },
        [
          _vm.DestroyIncomeStatistics == true
            ? _c("SelDc", {
                ref: "selectDcMultipleRef",
                attrs: { multipleSelectionFlag: true, id: _vm.tmSupplierId },
                on: { subCallMethod: _vm.selectDcMethod },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.AreaDialog, width: "400px" },
          on: {
            "update:visible": function ($event) {
              _vm.AreaDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "AreaForm",
              attrs: { model: _vm.AreaForm, "label-width": "60px" },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.country"),
                            prop: "country",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.countryChange },
                              model: {
                                value: _vm.AreaForm.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "country", $$v)
                                },
                                expression: "AreaForm.country",
                              },
                            },
                            _vm._l(_vm.countryList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.province"),
                            prop: "province",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.provinceChange },
                              model: {
                                value: _vm.AreaForm.province,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "province", $$v)
                                },
                                expression: "AreaForm.province",
                              },
                            },
                            _vm._l(_vm.provinceList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.city"),
                            prop: "city",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.cityChange },
                              model: {
                                value: _vm.AreaForm.city,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "city", $$v)
                                },
                                expression: "AreaForm.city",
                              },
                            },
                            _vm._l(_vm.cityList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("settlementUnit.tmAreaId"),
                            prop: "tmAreaId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: _vm.$t("common.sel") },
                              on: { change: _vm.AreaChange },
                              model: {
                                value: _vm.AreaForm.tmAreaId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.AreaForm, "tmAreaId", $$v)
                                },
                                expression: "AreaForm.tmAreaId",
                              },
                            },
                            _vm._l(_vm.AreaList, function (item) {
                              return _c("el-option", {
                                key: item.tmAreaId,
                                attrs: {
                                  clearable: "",
                                  label: item.name,
                                  value: item.tmAreaId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SubmitUnitOfAccount,
                      expression: "SubmitUnitOfAccount",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.saveArea },
                },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.AreaDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.qualificationsDialog,
            width: "50%",
            "before-close": _vm.closeQualificationsDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qualificationsDialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.qualificationsList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "HeaderName",
                  label: _vm.$t("common.file"),
                  "max-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "documentName",
                  label: _vm.$t("supplierManage.fileName"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.tmDocumentId
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.downloadQualifications(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.documentName) + " ")]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.documentName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              !_vm.disableAddressUserInput
                ? _c("el-table-column", {
                    attrs: {
                      width: "160px",
                      label: _vm.$t("common.operation"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "searchBox_bottom" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.SubmitUnitOfAccount,
                                        expression: "SubmitUnitOfAccount",
                                      },
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.getFileIndex(scope.$index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        attrs: {
                                          action: "upload",
                                          "http-request":
                                            _vm.uploadQualifications,
                                          "show-file-list": false,
                                          multiple: "",
                                          name: "file",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "trigger",
                                              size: "mini",
                                              type: "primary",
                                            },
                                            slot: "trigger",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("common.selectFile")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3436651462
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeQualificationsDialog },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.approvalVisible,
            width: "25%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approvaForm",
              attrs: {
                model: _vm.approvaForm,
                rules: _vm.approvaRules,
                inline: "",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.auditor"),
                    prop: "auditor",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.auditor,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditor", $$v)
                      },
                      expression: "approvaForm.auditor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalTime"),
                    prop: "approvalTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.approvalTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalTime", $$v)
                      },
                      expression: "approvaForm.approvalTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.RevisionComments"),
                    prop: "approvalResults",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.approvaForm.approvalResults,
                        callback: function ($$v) {
                          _vm.$set(_vm.approvaForm, "approvalResults", $$v)
                        },
                        expression: "approvaForm.approvalResults",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "PASS" } }, [
                        _vm._v(_vm._s(_vm.$t("common.pass"))),
                      ]),
                      _c("el-radio", { attrs: { label: "REJECT" } }, [
                        _vm._v(_vm._s(_vm.$t("common.noPass"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("settlementUnit.approvalRemarks"),
                    prop: "approvalRemarks",
                    rules:
                      _vm.approvaForm.approvalResults == "REJECT"
                        ? _vm.approvaForm.approvalRemarks
                        : [],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      maxlength: "300",
                    },
                    model: {
                      value: _vm.approvaForm.approvalRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalRemarks", $$v)
                      },
                      expression: "approvaForm.approvalRemarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.approvalVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.SubmitUnitOfAccount,
                      expression: "SubmitUnitOfAccount",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approvalConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addressAddSupplierContactListDialog,
            width: "80%",
            "before-close": _vm.closeSupplierContactsAddress,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addressAddSupplierContactListDialog = $event
            },
          },
        },
        [
          !_vm.disableAddressUserInput
            ? [
                _vm.addressAddSupplierContactListForm.addresslinkUsersList
                  .length < 5
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.SubmitUnitOfAccount,
                            expression: "SubmitUnitOfAccount",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addSupplierContactsAddress()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "acl",
                        rawName: "v-acl",
                        value: _vm.SubmitUnitOfAccount,
                        expression: "SubmitUnitOfAccount",
                      },
                    ],
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.delSupplierContactsAddress()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.del")))]
                ),
              ]
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "addressAddSupplierContactListForm",
              attrs: {
                model: _vm.addressAddSupplierContactListForm,
                rules: _vm.rulesAddressAddSupplierContactList,
              },
            },
            [
              _c(
                "el-table",
                {
                  ref: "addresslinkUsersList",
                  attrs: {
                    data: _vm.addressAddSupplierContactListForm
                      .addresslinkUsersList,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": "420",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "trLinkUserId",
                      type: "selection",
                      "min-width": "55",
                      selectable: (row) => !row.titleDisabled,
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "name",
                      label: _vm.$t("settlementUnit.contacts"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".name",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList.name,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.disableAddressUserInput,
                                  },
                                  model: {
                                    value: scope.row.name,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "tel",
                      label: _vm.$t("settlementUnit.tel"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".tel",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList.tel,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      maxlength: "60",
                                      disabled: _vm.disableAddressUserInput,
                                    },
                                    model: {
                                      value: scope.row.tel,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "tel", $$v)
                                      },
                                      expression: "scope.row.tel",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "officeTel",
                      label: "办公室电话",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".officeTel",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList
                                      .officeTel,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      maxlength: "60",
                                      disabled: _vm.disableAddressUserInput,
                                    },
                                    model: {
                                      value: scope.row.officeTel,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "officeTel", $$v)
                                      },
                                      expression: "scope.row.officeTel",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "email",
                      label: _vm.$t("settlementUnit.email"),
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".email",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList
                                      .email,
                                },
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      maxlength: "50",
                                      disabled: _vm.disableAddressUserInput,
                                    },
                                    model: {
                                      value: scope.row.email,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "email", $$v)
                                      },
                                      expression: "scope.row.email",
                                    },
                                  },
                                  [_vm._v(" ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "title",
                      label: "Title",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "addresslinkUsersList." +
                                    scope.$index +
                                    ".title",
                                  rules:
                                    _vm.rulesAddressAddSupplierContactList
                                      .title,
                                },
                              },
                              [
                                _vm.rowIndex == 0
                                  ? _c("ic-select", {
                                      attrs: {
                                        table: "TM_UNIT_OF_ACCOUNT",
                                        field: "REG_CONTACT_TYPE",
                                        disabled:
                                          scope.row.titleDisabled ||
                                          _vm.disableAddressUserInput,
                                      },
                                      model: {
                                        value: scope.row.title,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "title", $$v)
                                        },
                                        expression: "scope.row.title",
                                      },
                                    })
                                  : _c("ic-select", {
                                      attrs: {
                                        table: "TM_UNIT_OF_ACCOUNT",
                                        field: "PLANT_CONTACT_TYPE",
                                        disabled:
                                          scope.row.titleDisabled ||
                                          _vm.disableAddressUserInput,
                                      },
                                      model: {
                                        value: scope.row.title,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "title", $$v)
                                        },
                                        expression: "scope.row.title",
                                      },
                                    }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              !_vm.disableAddressUserInput
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SubmitUnitOfAccount,
                          expression: "SubmitUnitOfAccount",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.saveSupplierContactsAddress },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.closeSupplierContactsAddress()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "group_dialog",
          attrs: {
            visible: _vm.dialogVisible2,
            title: "工厂编码修改",
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible2 = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "plantCodeForm",
              staticClass: "plantCodeForm",
              attrs: {
                model: _vm.plantCodeForm,
                "label-width": "130px",
                "label-position": "right",
                rules: _vm.rulesPlantCode,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mandatory",
                          attrs: { label: "工厂编码", prop: "plantCode" },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.plantCodeForm.plantCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.plantCodeForm, "plantCode", $$v)
                              },
                              expression: "plantCodeForm.plantCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.SubmitUnitOfAccount,
                          expression: "SubmitUnitOfAccount",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.savePlantCode },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.cancelPlantCode },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }